export default class {
  constructor() {
    this.target = document.querySelector(".topMv_mov");
    if (!this.target) return;

    if (window.innerWidth > 768) return;

    this.wrapper = document.createElement("div");
    this.wrapper.className = "topMv_mov_wrapper";
    this.target.parentNode.insertBefore(this.wrapper, this.target);
    this.wrapper.appendChild(this.target);

    this.onResize = this.onResize.bind(this);
    this.onScroll = this.onScroll.bind(this);

    window.addEventListener("scroll", this.onScroll);
    window.addEventListener("resize", this.onResize);

    this.onResize();
    this.onScroll();
  }

  onResize() {
    if (window.innerWidth > 768) {
      this.wrapper.style.height = "";
      this.target.classList.remove("is-fixed");
      return;
    }
    // 非固定状態ならラッパーの高さをリセット
    if (!this.target.classList.contains("is-fixed")) {
      this.wrapper.style.height = "";
    }
  }

  onScroll() {
    if (window.innerWidth > 768) return;

    const rect = this.wrapper.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    
    // ラッパー自体の高さではなく、targetの高さを基準にする（ラッパーは高さ0の可能性もあるため）
    // ただし非固定時は targetの高さ = wrapperの本来の高さ
    const targetHeight = this.target.offsetHeight;

    const wrapperCenterY = rect.top + targetHeight / 2;
    const screenCenterY = windowHeight / 2;

    if (wrapperCenterY <= screenCenterY) {
      if (!this.target.classList.contains("is-fixed")) {
        // 固定する直前に、現在の高さをラッパーに設定してジャンプを防ぐ
        this.wrapper.style.height = `${this.target.offsetHeight}px`;
        this.target.classList.add("is-fixed");
      }
    } else {
      if (this.target.classList.contains("is-fixed")) {
        // 固定解除時にラッパーの高さをリセット
        this.target.classList.remove("is-fixed");
        this.wrapper.style.height = "";
      }
    }
  }
}
